/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Tracking_Searchlps2Inputs */

const en_coinvestments_tracking_searchlps2 = /** @type {(inputs: Coinvestments_Tracking_Searchlps2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search Organisations`)
};

/**
* | output |
* | --- |
* | "Search Organisations" |
*
* @param {Coinvestments_Tracking_Searchlps2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_tracking_searchlps2 = /** @type {((inputs?: Coinvestments_Tracking_Searchlps2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Tracking_Searchlps2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_tracking_searchlps2(inputs)
});
export { coinvestments_tracking_searchlps2 as "coInvestments_tracking_searchLps" }